import { createSlice } from '@reduxjs/toolkit';

export type DocumentListViewMode = 'grid' | 'list';

interface FormState {
  viewMode: DocumentListViewMode;
}

const initialState: FormState = {
  viewMode: 'grid'
};

const documentViewSlice = createSlice({
  name: 'documentList',
  initialState,
  reducers: {
    setGridView(state) {
      state.viewMode = 'grid';
    },
    setListView(state) {
      state.viewMode = 'list';
    },
    resetListState(state) {
      state.viewMode = 'grid';
    }
  }
});

export const { setGridView, setListView, resetListState } = documentViewSlice.actions;

export default documentViewSlice.reducer;
